t = require('views/internal/teacup-with-helpers')('reactions')
View = require 'view'
joinn = require 'joinn'

formattedName = (name) ->
  t.render ->
    t.span '.reaction-fullname', ->
      t.text name

formattedReaction = (reaction) ->
  t.render ->
    t.strong ->
      t.text reaction

template = t.renderable ({ names, reaction }) ->
  t.div '.reaction-tooltip', ->
    if names != ''
      t.raw t.l 'reaction-tooltip', {
        names,
        reaction: formattedReaction (reaction)
      }, { raw: true }
    else
      t.raw formattedReaction (reaction)

module.exports = class ReactionTooltip extends View
  renderOnce: ->
    { names, reaction } = @options
    names ?= []

    names = names.map formattedName
    names = joinn names, ', ', " #{ t.l 'and' } "

    @$el.append template { names, reaction }
    @



// WEBPACK FOOTER //
// ./app/scripts/views/reactions/reaction-tooltip.coffee